import {Component, OnDestroy} from "@angular/core";
import {BusinessService} from "../../../services/data/business.service";
import {Page} from "../../../model/page";
import {BusinessRight} from "../../../model/business-right";
import {AuthentService} from "../../../services/authent.service";
import {NotificationsService} from "angular2-notifications/components";
import {CurrentBusinessService} from "../../../services/communication/currentBusinessService";
import {UrlService} from "../../../services/url.service";
import {Subscription} from "rxjs";

@Component({
  selector: 'admin-list',
  template: require('./admin-list.component.html'),
  styles: [
    require('./admin-list.component.scss')
  ]
})

export class AdminListComponent implements OnDestroy {

  admins: BusinessRight[] = null;
  currentPage: Page<BusinessRight>;
  userRight: BusinessRight = null;
  adminToDelete: BusinessRight;

  adminLoading: boolean = false;

  private businessSubscription: Subscription = null;

  ngOnDestroy(): void {
    if (this.businessSubscription != null) {
      this.businessSubscription.unsubscribe();
    }
  }

  constructor(private businessService: BusinessService, private authent: AuthentService,
              private notificationService: NotificationsService, private currentBusinessService: CurrentBusinessService,
              private urlService: UrlService) {

    if (authent.getRight() == null) {
      authent.userRight$.subscribe(
        right => {
          this.userRight = right;
        }
      );
    } else {
      this.userRight = authent.getRight();
    }

    if (currentBusinessService.currentBusiness == null) {
      this.businessSubscription = currentBusinessService.businessChange$.subscribe(
        business => {
          this.loadAdmins();
        }
      );
    } else {
      this.loadAdmins();
    }
  }

  loadAdmins() {
    this.businessService.getAdmins(this.currentBusinessService.currentBusiness.id).subscribe(
      page => this.adminsLoaded(page),
      error => {
      }
    );
  }

  onScroll() {
    if (!this.adminLoading && !this.currentPage != null && !this.currentPage.last) {
      this.loadAdmins();
    }
  }

  adminsLoaded(admins: BusinessRight[]) {
    for (let admin of admins) {
      // if (admin.member.name == null) {
      //   admin.member.name = admin.member.email;
      // }

      admin.avatarUrl = this.urlService.getMemberAvatarUrl(admin.member.id);
    }

    this.admins = admins;
  }

  canAdministrate(right?: BusinessRight): boolean {
    if (this.userRight != null && right.id != this.userRight.id) {
      return this.userRight.canAdministrate;
    }

    return false;
  }

  administrateChange(right: BusinessRight): void {
    this.updateRight(right);
  }

  createChange(right: BusinessRight): void {
    this.updateRight(right);
  }

  moderateChange(right: BusinessRight): void {
    this.updateRight(right);
  }

  selectAdmin(right: BusinessRight): void {
    this.adminToDelete = right;
  }

  deleteAdmin(): void {
    this.businessService.removeAdmin(this.currentBusinessService.currentBusiness.id, this.adminToDelete.member.id).subscribe(
      response => {
        this.loadAdmins();
      }
    );
  }

  private updateRight(right: BusinessRight): void {
    this.businessService.updateRight(right).subscribe(
      right => {
        this.admins.map(function (obj) {

          if (obj.id == right.id) {
            obj = right;
          }

          return obj;
        });
        this.notificationService.success('Administration', 'Le changement de droit a été pris en compte');
      }
    );
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/components/admin/admin-list/admin-list.component.ts